<template>
	<!-- <el-dialog title="选择反馈对象" :modal="false" :modal-append-to-body="false" :visible.sync="dialogVisible" :before-close="handleClose" class="select-push" :close-on-click-modal="false"> -->
		<div class="selectPushIn">
			<div class="leftBox">
				<el-input placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
				<div class="listArea">
					<el-scrollbar style="height:100%">
						<el-tree :data="treeNode" show-checkbox node-key="id" :default-expanded-keys="defaultExpandedKeys" :default-checked-keys="checkedKeys" :props="defaultProps" :filter-node-method="filterNode" ref="tree" @check="check" ></el-tree>
					</el-scrollbar>
				</div>
			</div>
			<div class="rightBox">
				<div class="tit">已选择单位 ( {{ checkedKeys.length }} )</div>
				<div class="rightList">
					<el-scrollbar style="height:100%">
						<div class="item" v-if="allChecked">
							<span>
								<i class="dian"></i>
								全选
							</span>
							<i class="iconfont iconcha" @click="empty"></i>
						</div>
						<div class="item" v-else v-for="(item, index) in checkedNodes" :key="index">
							<span>
								<i class="dian"></i>
								{{ item.label }}
							</span>
							<i class="iconfont iconcha" @click="delNode(item)"></i>
						</div>
					</el-scrollbar>
				</div>
			</div>
		</div>
		<!-- <span slot="footer" class="dialog-footer">
			<el-button @click="addObj" icon="iconfont iconqueding" class="flex-btn btns queding-btn">确 定</el-button>
			<el-button @click="handleClose" icon="iconfont iconquxiao" class="flex-btn btns fanhui-btn">取 消</el-button>
		</span> -->
	<!-- </el-dialog> -->
</template>

<script>
export default {
	name: 'addFeedback',
	components: {},
	data() {
		return {
			dialogVisible: false,
			treeNode: [],
			defaultProps: {
				children: 'children',
				label: 'label'
			},
			filterText: '',
			checkedKeys: [],//已选的id
			checkedNodes: [],//已选成员
			allChecked: false,
			ejNodes: [],
			defaultExpandedKeys:[1]
		};
	},
	props: {
		selectedNode: Array,
		allCheckval: Boolean,
		treeNode22: Array
	},
	created() {},
	mounted() {},
	computed: {},
	methods: {
		initPage: function() {
			// this.selectedNode.forEach(element => {
			// 	//对props过来的数据push分组
			// 	this.checkedNodes.push(element);
			// 	this.checkedKeys.push(element.id);
			// });
			// if (this.allCheckval) {
			// 	this.allChecked = true;
			// }
			this.treeNode = this.treeNode22;
			// this.treeNode[0].children.forEach(element => {
			// 	this.defaultExpandedKeys.push(element.id)
			// });
			this.getejNodes();
		},
		show: function() {
			this.dialogVisible = true;
		},
		filterNode(value, data) {
			if (!value) return true;
			return data.label.indexOf(value) !== -1;
		},
		check(nodeObject, treeSelectObject) {
			this.checkedKeys = [];
			this.checkedNodes = [];
			if (treeSelectObject.checkedKeys[0] == 1) {
				//全选
				this.allChecked = true;
				for (let index = 0; index < treeSelectObject.checkedNodes.length; index++) {
					const element = treeSelectObject.checkedNodes[index];
					if (this.ejNodes.indexOf(element.id) == -1 && element.id !== 1) {
						this.checkedNodes.push(element);
						this.checkedKeys.push(element.id);
					}
				}
			} else {
				this.allChecked = false;
				for (let index = 0; index < treeSelectObject.checkedNodes.length; index++) {
					const element = treeSelectObject.checkedNodes[index];
					if (this.ejNodes.indexOf(element.id) == -1) {
						this.checkedNodes.push(element);
						this.checkedKeys.push(element.id);
					}
				}
			}
			this.$emit('getFinalCheckNodes', this.checkedNodes);
		},
		getejNodes() {
			//获取二级菜单id
			let list = JSON.parse(JSON.stringify(this.treeNode));
			list[0].children.forEach(element => {
				//父节点
				this.ejNodes.push(element.id);
			});
			this.$nextTick(() => {
				this.$refs.tree.setCheckedKeys(this.checkedKeys,true);
				// this.$refs.tree.setChecked(this.checkedKeys,true, true);
			});
		},
		delNode(item) {
			this.$refs.tree.setChecked(item.id, false, true);
			for (let index = 0; index < this.checkedNodes.length; index++) {
				const element = this.checkedNodes[index];
				if (element.id == item.id) {
					this.checkedNodes.splice(index, 1);
				}
			}
			for (let index = 0; index < this.checkedKeys.length; index++) {
				const element = this.checkedKeys[index];
				if (element == item.id) {
					this.checkedKeys.splice(index, 1);
				}
			}
			this.$emit('getFinalCheckNodes', this.checkedNodes);
		},
		empty() {
			this.$refs.tree.setCheckedKeys([]);
			this.checkedKeys = [];
			this.checkedNodes = [];
			this.allChecked = false;
			this.$emit('getFinalCheckNodes', this.checkedNodes);
		},
		getCheckNodesEvent() {
			//let tt=this.$refs.tree.getCheckedNodes()
			this.$emit('getFinalCheckNodes', this.checkedNodes);
			this.$emit('allCheck', this.allChecked);
		},
		handleClose(done) {
			this.$reset('', []);
			this.dialogVisible = false;
		},
		addObj: function() {
			if(this.checkedNodes.length > 10){
				this.checkedNodes = this.checkedNodes.splice(0, 10);
				this.allChecked = false
			}
			this.$emit('getFinalCheckNodes', this.checkedNodes,this.allChecked);
			// this.$emit('allCheck', this.allChecked);
			// this.$emit('popupSure');
			this.handleClose();
		}
	},
	watch: {
		filterText(val) {
			this.$refs.tree.filter(val);
		},
		dialogVisible: {
			handler: function(val, oldval) {
				let that = this;
				if (val) {
					this.initPage();
				} else {
				}
			},
			deep: true //对象内部的属性监听，也叫深度监听
		}
	},
	filters: {}
};
</script>

<style scoped lang="less">
@import './addFeedback.less';
</style>
